<p-toast></p-toast>
<div class="mw-100" style="background-color: white; height: 100%;">
    <app-navbar></app-navbar>
    <div class="container">
      <form autocomplete="off" class="form-horizontal" enctype="multipart/form-data" (ngSubmit)="actualizarLista()">
        <div class="p-card p-component">
          <div class="button" style="margin-left: 15px;">
            <button class="p-button p-component btn" (click)="regresar(deviceUrl, deviceName)">{{ 'BACK' | translate}}</button>
        </div>
          <div class="p-card-header p-component p-card-header-primary">
            <h5 class="pdfs-15">{{ 'EDIT_LIST_CONTACT' | translate}}</h5>
          </div>
          <div class="p-card-body p-component">
      
            <!-- List Name -->
            <div class="p-grid">
              <div class="p-col-3">
                <label class="customfont1">{{ 'LIST_NAME' | translate}}</label>
              </div>
              <div class="p-col-7">
                <div class="p-field p-fluid">
                  <input class="p-inputtext p-component inputfiled" name="txt-nombreLista" id="txt-webHook" type="text" placeholder="{{ 'LIST_NAME_EXAMPLE' | translate}}" aria-required="true" required [(ngModel)]="lista.nombre"/>
                  <!--Validacion de campo-->
                  <div *ngIf="validar && !lista.nombre">
                    <div class="alerta">
                      <span>{{ 'REQUIRED_FILE' | translate}}</span>
                    </div>
                  </div>
                  <!--Validacion de campo-->
                </div>
              </div>
            </div>
  
          <!-- List Type -->
            <div class="p-grid">
              <div class="p-col-3">
                <label class="customfont1" for="txt-tipoLista">{{ 'LIST_TYPE' | translate}}</label>
              </div>
              <div class="p-col-7">
                <div class="p-field p-fluid">
                  <select id="txt-tipoLista" name="txt-tipoLista" class="p-dropdown my-select" [(ngModel)]="lista.tipoLista">
                    <option class="inputfiled" value="enviar-mensaje-muchos-contactos">{{ 'LIST_1' | translate}}</option>
                    <option class="inputfiled" value="enviar-muchos-mensajes-muchos-contactos">{{ 'LIST_2' | translate}}</option>
                    <option class="inputfiled" value="enviar-muchos-archivos-muchos-contactos">{{ 'LIST_3' | translate}}</option>
                  </select>
                </div>
              </div>
            </div>
           <!-- Opción de ingreso manual -->
            <div class="p-grid">
              <div class="p-col-3">
                <div class="p-field-checkbox">
                  <input type="radio" name="opcionLista" value="1" id="opc1" class="p-radiobutton-input" (change)="cambioSeleccion(1)" [checked]="ingresoManualSeleccionado">
                <label class="customfont1" for="opc1">{{ 'MANUAL_ENTRY_LIST' | translate}}</label>
                </div>
              </div>
              <div class="p-col-7">
                <div class="p-field p-fluid">
                  <textarea class="p-inputtext p-component inputfiled" name="txt-telefonos" id="txt-telefonos" rows="10" required [(ngModel)]="lista.lista" resize="none"
                  placeholder="{{ 'NUMBERS' | translate}}:&#10;5215555555555&#10;5215555555555&#10;5215555555555" [disabled]="!ingresoManualSeleccionado"></textarea>
                  <!--Validación campo-->
                  <div *ngIf="lista.lista && !verificarSoloNumeros(lista.lista)" class="alerta">
                    <div class="alerta">
                      <span>{{ 'ONLY_NUMBERS' | translate}}</span>
                    </div>
                  </div>
                <!--Validación campo--> 
                </div>
              </div>
            </div>
            <!-- Opción de ingreso por CSV -->
            <div class="p-grid">
              <div class="p-col-3">
                <div class="p-formgroup-inline">
                  <div class="p-field-checkbox">
                    <input type="radio" name="opcionLista" value="2" id="opc2" class="p-radiobutton-input" (change)="cambioSeleccion(2)" [checked]="importacionCsvSeleccionada">
                    <label for="opc2" class="customfont1">{{ 'CSV_ENTRY' | translate}}</label>
                  </div>
                </div>
              </div>
              <div class="p-col-7">
                <div class="p-field p-fluid">
                    <input class="p-inputtext p-component inputfiled" name="txt-archivoTelefonos" id="txt-archivoTelefonos" type="file" aria-required="true" (change)="onFileSelected($event)"
                    [disabled]="!importacionCsvSeleccionada"/>
                </div>
              </div>
            </div>
  
          </div>
          <div class="p-card-footer ml-auto mr-auto boton">
            <button type="submit" class="p-button p-component btn">{{ 'UPDATE_LIST' | translate}}</button>
          </div>
        </div>
      </form>
      
      
    </div>
  </div>
  